import type { JSX } from 'react';

export function ErrorText({ children }: { children: string }): JSX.Element {
  return <p style={{ color: '#dc2626', fontSize: 13, margin: 0 }}>{children}</p>;
}
